import { Map } from "immutable";
import segurosAction from "./actions";

const colors = ["#7ED321", "#de1b1b", "#511E78", "#ff9009", "#42a5f5"];
const selectseguro = {};
const quotes = {};

const initState = new Map({
  colors,
  selectseguro,
  quotes,
  current_step: 0,
  are_in_form: false,
  allow_payment_submit: false,
  allow_next_step_form: false,
  stripe_form_completed: false,
  valid_borndate: false,
  index_loaded: false,
  content_loaded: false,
  payment_made: {
    show: false,
  },
  carros_dterceros: true,
  motos_dterceros: false,
  driver_form_without_erros: false,
  vehicle_form_without_errors: false,
  driver_form_completed: false,
  driver_form_id_completed: false,
  vehicle_form_completed: false,
  allow_cyberpayment: false,
  cyber_form_completed: false,
  cyber_form_data: null,
  pay_form_completed: false,
  bot_form_driver_completed: false,
  fc_form_driver_completed: false,
  bot_form_vehicle_completed: false,
  are_in_bot_form: false,
  pay_card_type: "000",
  cyber_post_response: "",
  emision_response: "",
  emision_error_message: "",
  cars_api_data: [],
  cycles_api_data: [],
  expresspayment_cyber_form_data: {},
  expresspayment_backend_response: {},
  have_policy_pic: false,
  expired_form_filled: false,
  unsup_card_type: false,
  overyear_vehicle: false,
  adblocker_detected: false,
  show_homepage: true,
  bank_transfer_process: false,
  yappy_transfer_process: false,
  not_show_popup: false,
  return_from_same_mode: false,
  cycles_landing_mode: false,
  current_referrer: "",
  is_fetching_referral_quote: false,
  referral_quote_data: {},
  emision_with_soap_response: "",
  bot_fail_form_completed: false,
  bot_fail_form_user_id: "",
  dt_customer_data_stored: "",
  bot_fail_form_emision_response: "",
  referral_id: "",
  wts_modal_used: true,
  blacklisted_user: false,
  yappy_response: false,
  first_step_reloaded: false,
  selected_policy: "",
  renew_user_id: "",
  isMoroso: false,
  renewalPlan: {},
  use_tokenization: false,
  insurance_mode: false,
  payment_monthly_skip: "0",
  is_renewing_policy: false,
  renewedpolicy: {
    error: false,
    message: "",
    status: false,
    url: false,
    poliza: false,
    renew_user_id: false,
  },
  renew_has_been_called: false,
  policies_modal_visible: false,
  loading: false,
  policie_emited_yappy: false,
  renewalMonthlyPayment: null,
  dtMonthlyPayment: true,
  dataCollectionFilter: "email",
  pickUpModalVisible: false,
  pickUpISPolicie: {},
  selectCedulaPas: 1,
  primaBankTransfer: 0,
  hasPickUp: false,
  overYearModalVisible: false,
  renewTokenResult: {},
  moreThanAMonthAway: false,
  customerPaymentData: null,
  referred_code: null
});

export default function segurosReducer(state = initState, action) {

  const quotes = state.get("quotes");
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.Seguros);
      } else {
        return state;
      }
    case segurosAction.CARROS_DTERCEROS:
      return state.set("carros_dterceros", action.carros_dterceros);
    case segurosAction.MOTOS_DTERCEROS:
      return state.set("motos_dterceros", action.motos_dterceros);
    case segurosAction.SELECT_COB_BASICA:
      return state.set("coberturaDTerceros", action.selectCobBasica);
    case segurosAction.SELECT_SEGURO_DT:
      return state.set("selectseguro", action.selectseguro);
    case segurosAction.HASELECT_SEGURO_DT:
      return state.set("haseleccionadoseguro", action.haseleccionadoseguro);
    case segurosAction.SELECT_CARRO:
      return state.set("selectCarro", action.selectCarro);
    case segurosAction.TIPO_COBERTURA:
      return state.set("tipoCobertura", action.tipoCobertura);
    case segurosAction.NOT_SHOW_LANDING:
      return state.set("not_show_landing", action.not_show_landing);
    case segurosAction.ADD_QUOTE:
      return state.set("quotes", [...quotes, action.quotes]);
    case segurosAction.SEL_SEGURO:
      return state.set("selseguro", action.selseguro);
    case segurosAction.CEDULA_PASAPORTE:
      return state.set("selectCedulaPas", action.selectCedulaPas);
    case segurosAction.SELECCION_SEGURO:
      return state.set("selecciondeseguro", action.selecciondeseguro);
    case segurosAction.CONVERTIR_PDF:
      return state.set("convertirapdf", action.convertirapdf);
    case segurosAction.SEL_LIMITES:
      return state.set("limites", action.limites);
    case segurosAction.INTRERCOM_LISTO:
      return state.set("intercomlisto", action.intercomlisto);
    case segurosAction.RES_QUOTE:
      return state.set("quotes", action.quotes);
    case segurosAction.SEL_SEGURO_CC:
      return state.set("selsegurocc", action.selsegurocc);
    case segurosAction.SET_CURRENT_STEP:
      return state.set("current_step", action.current_step);
    case segurosAction.ARE_IN_FORM:
      return state.set("are_in_form", action.are_in_form);
    case segurosAction.SHOW_SPIN_FORM:
      return state.set("show_spin_form", action.show_spin_form);
    case segurosAction.FORM_ERROR_MESSAGE:
      return state.set("form_error_message", action.form_error_message);
    case segurosAction.ALLOW_PAYMENT_SUBMIT:
      return state.set("allow_payment_submit", action.allow_payment_submit);
    case segurosAction.ALLOW_NEXT_STEP_FORM:
      return state.set("allow_next_step_form", action.allow_next_step_form);
    case segurosAction.STRIPE_FORM_COMPLETED:
      return state.set("stripe_form_completed", action.stripe_form_completed);
    case segurosAction.VALID_BORNDATE:
      return state.set("valid_borndate", action.valid_borndate);
    case segurosAction.CYBER_FORM_DATA:
      return state.set("cyber_form_data", action.cyber_form_data);
    case segurosAction.INDEX_LOADED:
      return state.set("index_loaded", action.index_loaded);
    case segurosAction.CONTENT_LOADED:
      return state.set("content_loaded", action.content_loaded);
    case segurosAction.PAYMENT_MADE:
      return state.set("payment_made", action.payment_made);
    case segurosAction.DRIVER_FORM_WITHOUT_ERRORS:
      return state.set(
        "driver_form_without_errors",
        action.driver_form_without_erros
      );
    case segurosAction.VEHICLE_FORM_WITHOUT_ERRORS:
      return state.set(
        "vehicle_form_without_errors",
        action.vehicle_form_without_errors
      );
    case segurosAction.DRIVER_FORM_COMPLETED:
      return state.set("driver_form_completed", action.driver_form_completed);
    case segurosAction.DRIVER_FORM_ID_COMPLETED:
      return state.set(
        "driver_form_id_completed",
        action.driver_form_id_completed
      );
    case segurosAction.VEHICLE_FORM_COMPLETED:
      return state.set("vehicle_form_completed", action.vehicle_form_completed);
    case segurosAction.ALLOW_CYBERPAYMENT:
      return state.set("allow_cyberpayment", action.allow_cyberpayment);
    case segurosAction.CYBER_FORM_COMPLETED:
      return state.set("cyber_form_completed", action.cyber_form_completed);
    case segurosAction.PAY_FORM_COMPLETED:
      return state.set("pay_form_completed", action.pay_form_completed);
    case segurosAction.BOT_FORM_DRIVER_COMPLETED:
      return state.set(
        "bot_form_driver_completed",
        action.bot_form_driver_completed
      );
    case segurosAction.FC_FORM_DRIVER_COMPLETED:
      return state.set(
        "fc_form_driver_completed",
        action.fc_form_driver_completed
      );
    case segurosAction.BOT_FORM_VEHICLE_COMPLETED:
      return state.set(
        "bot_form_vehicle_completed",
        action.bot_form_vehicle_completed
      );
    case segurosAction.ARE_IN_BOT_FORM:
      return state.set("are_in_bot_form", action.are_in_bot_form);
    case segurosAction.PAY_CARD_TYPE:
      return state.set("pay_card_type", action.pay_card_type);
    case segurosAction.CYBER_POST_RESPONSE:
      return state.set("cyber_post_response", action.cyber_post_response);
    case segurosAction.EMISION_RESPONSE:
      return state.set("emision_response", action.emision_response);
    case segurosAction.EMISION_ERROR_MESSAGE:
      return state.set("emision_error_message", action.emision_error_message);
    case segurosAction.REQUEST_CARS_API:
      return state.set("request_cars_api", action.request_cars_api);
    case segurosAction.REQUEST_USER_IP:
      return state.set("request_user_ip", action.request_user_ip);
    case segurosAction.CARS_API_DATA:
      return state.set("cars_api_data", action.cars_api_data);
    case segurosAction.USER_IP:
      return state.set("user_ip", action.user_ip);
    case segurosAction.SET_INTERCOM_HASH:
      return state.set("intercom_hash", action.hashData);
    /* 
    case segurosAction.CYCLES_API_DATA:
      return state.set("cycles_api_data", action.cycles_api_data); */
    case segurosAction.EXPRESSPAYMENT_CYBER_FORM_DATA:
      return state.set(
        "expresspayment_cyber_form_data",
        action.expresspayment_cyber_form_data
      );
    case segurosAction.EXPRESSPAYMENT_FORM_COMPLETED:
      return state.set(
        "express_payment_form_completed",
        action.express_payment_form_completed
      );
    case segurosAction.EXPRESSPAYMENT_ERROR_MESSAGE:
      return state.set(
        "expresspayment_error_message",
        action.expresspayment_error_message
      );
    case segurosAction.EXPRESSPAYMENT_CYBER_POST_RESPONSE:
      return state.set(
        "expresspayment_cyber_post_response",
        action.expresspayment_cyber_post_response
      );
    case segurosAction.EXPRESSPAYMENT_URL_PROPS:
      return state.set(
        "expresspayment_url_props",
        action.expresspayment_url_props
      );
    case segurosAction.EXPRESSPAYMENT_BACKEND_RESPONSE:
      return state.set(
        "expresspayment_backend_response",
        action.expresspayment_backend_response
      );
    case segurosAction.EXPRESSPAYMENT_FULL_URL:
      return state.set(
        "expresspayment_full_url",
        action.expresspayment_full_url
      );
    case segurosAction.HAVE_POLICY_PIC:
      return state.set("have_policy_pic", action.have_policy_pic);
    case segurosAction.EXPIRED_FORM_FILLED:
      return state.set("expired_form_filled", action.expired_form_filled);
    case segurosAction.UNSUP_CARD_TYPE:
      return state.set("unsup_card_type", action.unsup_card_type);
    case segurosAction.OVERYEAR_VEHICLE:
      return state.set("overyear_vehicle", action.overyear_vehicle);
    case segurosAction.ADBLOCKER_DETECTED:
      return state.set("adblocker_detected", action.adblocker_detected);
    case segurosAction.SHOW_HOMEPAGE:
      return state.set("show_homepage", action.show_homepage);
    case segurosAction.BANK_TRANSFER_PROCESS:
      return state.set("bank_transfer_process", action.bank_transfer_process);
    case segurosAction.YAPPY_TRANSFER_PROCESS:
      return state.set("yappy_transfer_process", action.yappy_transfer_process);
    case segurosAction.NOT_SHOW_POPUP:
      return state.set("not_show_popup", action.not_show_popup);
    case segurosAction.RETURN_FROM_SAME_MODE:
      return state.set("return_from_same_mode", action.return_from_same_mode);
    case segurosAction.CYCLES_LANDING_MODE:
      return state.set("cycles_landing_mode", action.cycles_landing_mode);
    case segurosAction.CURRENT_REFERRER:
      return state.set("current_referrer", action.current_referrer);
    case segurosAction.REFERRED_CODE:
        return state.set("referred_code", action.referred_code);
    case segurosAction.IS_FETCHING_REFERRAL_QUOTE:
      return state.set(
        "is_fetching_referral_quote",
        action.is_fetching_referral_quote
      );
    case segurosAction.SET_REFERRAL_QUOTE:
      return state.set("referral_quote_data", action.referral_quote_data);
    case segurosAction.EMISION_WITH_SOAP_RESPONSE:
      return state.set(
        "emision_with_soap_response",
        action.emision_with_soap_response
      );
    case segurosAction.BOT_FAIL_FORM_COMPLETED:
      return state.set(
        "bot_fail_form_completed",
        action.bot_fail_form_completed
      );
    case segurosAction.BOT_FAIL_FORM_USER_ID:
      return state.set("bot_fail_form_user_id", action.bot_fail_form_user_id);
    case segurosAction.DT_CUSTOMER_DATA_STORED:
      return state.set(
        "dt_customer_data_stored",
        action.dt_customer_data_stored
      );
    case segurosAction.BOT_FAIL_FORM_EMISION_RESPONSE:
      return state.set(
        "bot_fail_form_emision_response",
        action.bot_fail_form_emision_response
      );
    case segurosAction.REFERRAL_ID:
      return state.set("referral_id", action.referral_id);
    case segurosAction.WTS_MODAL_USED:
      return state.set("wts_modal_used", action.wts_modal_used);
    case segurosAction.BLACKLISTED_USER:
      return state.set("blacklisted_user", action.blacklisted_user);
    case segurosAction.YAPPY_RESPONSE:
      return state.set("yappy_response", action.yappy_response);
    case segurosAction.FIRST_STEP_RELOADED:
      return state.set("first_step_reloaded", action.first_step_reloaded);
    case segurosAction.SELECTED_POLICY:
      return state.set("selected_policy", action.selected_policy);
    case segurosAction.RENEW_USER_ID:
      return state.set("renew_user_id", action.renew_user_id);
    case segurosAction.DT_CUSTOMER_IS_MOROSO:
      return state.set("isMoroso", action.isMoroso);
    case segurosAction.DT_SET_RENEWAL_PLAN:
      return state.set("renewalPlan", action.renewalPlan);
    case segurosAction.DT_SET_USE_TOKENIZATION:
      return state.set("use_tokenization", action.use_tokenization);
    case segurosAction.INSURANCE_MODE:
      return state.set("insurance_mode", action.insurance_mode);
    case segurosAction.PAYMENT_MONTHLY_SKIP:
      return state.set("payment_monthly_skip", action.payment_monthly_skip);
    case segurosAction.IS_RENEWING_POLICY:
      return state.set("is_renewing_policy", action.is_renewing_policy);
    case segurosAction.SET_RENEWED_POLICY:
      return state.set("renewedpolicy", action.renewedpolicy);
    case segurosAction.RENEW_POLICY_HAS_BEEN_CALLED:
      return state.set("renew_has_been_called", action.renew_has_been_called);
    case segurosAction.POLICIES_MODAL_VISIBLE:
      return state.set("policies_modal_visible", action.policies_modal_visible);
    case segurosAction.SETLOADING:
      return state.set("loading", true);
    case segurosAction.REMOVELOADING:
      return state.set("loading", false);
    case segurosAction.SET_POLICIE_EMITED_YAPPY:
      return state.set("policie_emited_yappy", action.value);
    case segurosAction.SETRENEWALMONTHLYPAYMENT:
      return state.set("renewalMonthlyPayment", action.value);
    case segurosAction.SETDTMONTHLYPAYMENT:
      return state.set("dtMonthlyPayment", action.value);
    case segurosAction.SETDATACOLLECTIONFILTER:
      return state.set("dataCollectionFilter", action.value);
    case segurosAction.SETPICKUPMODALVISIBLE:
      return state.set("pickUpModalVisible", action.value);
    case segurosAction.SETPICKUPISPOLICIE:
      return state.set("pickUpISPolicie", action.value);
    case segurosAction.SETPRIMABANKTRANSFER:
      return state.set("primaBankTransfer", action.value);
    case segurosAction.SETHASPICKUP:
      return state.set("hasPickUp", action.value);
    case segurosAction.SETOVERYEARMODALVISIBLE:
      return state.set("overYearModalVisible", action.value);
    case segurosAction.SETRENEWTOKENRESULT:
      return state.set("renewTokenResult", action.value);
    case segurosAction.SETMORETHANAMONTHAWAY:
      return state.set("moreThanAMonthAway", action.value);
    case segurosAction.SETCUSTOMERPAYMENTDATA:
      return state.set("customerPaymentData", action.value);
    default:
      return state;
  }
}
